import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/images/og_image_default.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/AppDownloadSection/assets/mobilePhonePreview.png");
;
import(/* webpackMode: "eager", webpackExports: ["AppRatingSection"] */ "/app/src/components/AppRatingSection/AppRatingSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Clickables/Buttons/AppStoreButtons/AppStoreButtons.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/CTAs/DownloadAppHorizontalCTA/assets/AppsBannerBackground.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/CTAs/DownloadAppHorizontalCTA/assets/logo.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/QRCode/QRCode.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CircleImage"] */ "/app/src/views/Features/components/CircleImage.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/views/Features/DepthMapsFeatures/assets/depthMapBackground.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/Features/DepthMapsFeatures/assets/depthMapsPhoneOne.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/Features/FishingForecastsFeatures/assets/fishingForecastsPhoneOne.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/Features/FishingSpotsFeatures/assets/fishingSpotsPhoneOne.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/Features/FishingSpotsFeatures/assets/fishingSpotsPhoneTwo.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/Features/LogbookFeatures/assets/logbookPhone.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/Features/WaypointsFeatures/assets/waypointsPhoneTwo.png");
